export default __webpack_public_path__ + "static/media/img_welcome.b7a0c308.svg";